import { render } from "./OrderList.vue?vue&type=template&id=77281af2&ts=true"
import script from "./OrderList.vue?vue&type=script&lang=ts"
export * from "./OrderList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__